<template>
  <div class="arrow">
    <v-icon color="#47cf73">mdi-arrow-right</v-icon>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.arrow {
  padding: 10px;
  animation: bounce 0.6s;
  animation-direction: alternate;
  animation-iteration-count: infinite;
}

@keyframes bounce {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    transform: translate3d(10px, 0px, 0);
  }
}
</style>
